import React, {FC} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field} from 'formik'

const Step4: FC = () => {
  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Chụp ảnh hồ sơ</h2>
        </div>
        <div className='text-center'>
          <span className='d-block'>Vui lòng chụp ảnh CMND/CCCD còn hiệu lực.</span>
        </div>

        <div className='d-flex justify-content-center mt-4'>
          <div className='mx-5'>
            <img src={toAbsoluteUrl('/media/nhsv/cccd-mt.png')} alt='img' />
          </div>
          <div className='mx-5'>
            <img src={toAbsoluteUrl('/media/nhsv/cccd-ms.png')} alt='img' />
          </div>
        </div>

        <div className='mt-5'>
          <h4>Vui lòng làm theo hướng dẫn</h4>
          <div>
            <div>
              <i className='bi bi-check-circle-fill text-success'></i>
              <span className='mx-2'>Sử dụng giấy tờ bản gốc và còn hiệu lực</span>
            </div>
            <div>
              <i className='bi bi-check-circle-fill text-success'></i>
              <span className='mx-2'>Chụp ảnh không bị che khuất và không thiếu mất góc cạnh.</span>
            </div>
            <div>
              <i className='bi bi-check-circle-fill text-success'></i>
              <span className='mx-2'>Chụp ảnh trong không gian đủ sáng, không bị nhòe.</span>
            </div>
            <div>
              <i className='bi bi-check-circle-fill text-success'></i>
              <span className='mx-2'>
                Khách hàng đồng ý NHSV sử dụng thông tin, hình ảnh vào mục đích xác thực theo quy
                định của NHSV.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Step4}
